import { render, staticRenderFns } from "./VisitorFormIcon.vue?vue&type=template&id=356776c2&scoped=true"
import script from "./VisitorFormIcon.vue?vue&type=script&lang=js"
export * from "./VisitorFormIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "356776c2",
  null
  
)

export default component.exports